import { ReactNode } from 'react';
// Types
import Colors from 'app/types/Colors';
// Mui
import { Box, SxProps } from '@mui/material';
// Utils
import { ColorPaletteContext } from './utils/useColorPaletteContext';
// Constants
import { NO_COLOR_VALUE } from 'app/App.constants';
// 
import ColorPaletteItem from './ColorPaletteItem';

type Props = {
  sx?: SxProps;
  initialColors?: string[];
  showNoColorValue?: boolean;
  activeColors?: string[];
  children: (color:string, idx:number) => ReactNode;
}

const ColorPaletteComponent = ({ sx = {}, initialColors, showNoColorValue = true, activeColors, children }:Props) => {
  const colors = Object.values(Colors);
  const allColors = initialColors || (showNoColorValue ? [NO_COLOR_VALUE, ...colors] : colors);

  if ( !allColors.length ) return null;
  return (
    <ColorPaletteContext.Provider value={{ showNoColorValue, activeColors }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, ...sx }}>
        {allColors.map((color, idx) => children(color, idx))}
      </Box>
    </ColorPaletteContext.Provider>
  )
}

const ColorPalette = Object.assign(ColorPaletteComponent, {
  Item: ColorPaletteItem
});

export default ColorPalette;
